import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../service/login/login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.css']
})
export class OrganizationComponent implements OnInit {
  type = '组织机构'
  news: any = []
  constructor(private service: LoginService, private router: Router) { }
  getInfo() {
    this.service.getNews(this.type).subscribe((res: any) => {
      this.news = res['result']
    })
  }
  detail(e) {
    console.log('我看下这个能不能获取到id', e)
    localStorage.setItem('detailtit', e.title)
    localStorage.setItem('detailtime', e.time)
    localStorage.setItem('detailcontent', e.content)
    localStorage.setItem('detailImg', e.fileid)
    this.router.navigate(['/detail'])
  }
  ngOnInit() {
    this.getInfo()
  }

}
